exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".file-content {\n    text-align: center;\n    /*overflow-y: auto;*/\n    /*overflow-x: visible;*/\n    /*max-height:1200px;*/\n}\n.file-image {\n    max-width: 100%;\n}\n.group-panel{\n    border: none;\n}\n.group-title{\n    margin:0;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.panel-file{\n    border:0;\n    border-radius:0;\n    margin:0;\n}\n.panel-file .panel-heading {\n    border:0;\n    border-radius:0;\n    background-color:#d6e9c6;\n    color: #337ab7;\n}\n.link{\n    cursor: pointer;\n    color:#428bca;\n}\n.link:hover{\n    text-decoration: underline;\n}\n.bottom-action{\n    padding-bottom:50px;\n    text-align:center;\n}\n\n.x-left {\n    margin-top: -6px;\n    position: relative;\n    float: left;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/views/file-preview/file-preview.css
// module id = 1218
// module chunks = 9